import React from 'react';
import icon from './icon.png';

const Navbar = () => {
  return (
    <header>
      <div className='collapse bg-dark ' id='navbarHeader'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-8 col-md-7 py-4'>
              <h4 className='text-white'>About</h4>
              <p className='text-muted'>
                I am Harshit, a front-end developer and general doodler with a
                keen eye for creating engaging UI, bringing products to life.
              </p>
            </div>
            <div className='col-sm-4 offset-md-1 py-4'>
              <h4 className='text-white'>Contact</h4>
              <div className='links'>
                <a
                  href='https://www.linkedin.com/in/harshit-kumar-ab98a3191/'
                  className='text-white'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <i className='fab fa-linkedin'></i>
                </a>

                <a
                  href='mailto:kumarharshit850@gmail.com'
                  className='text-white'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <i className='fas fa-envelope'></i>
                </a>

                <a
                  href='https://wa.me/919557789396'
                  className='text-white'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <i className='fab fa-whatsapp'></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='navbar navbar-dark bg-dark shadow-sm'>
        <div className='container'>
          <img
            src={icon}
            width='35'
            className='navbar-brand d-flex align-items-center'
            alt='icon'
          />

          <button
            className='navbar-toggler shadow-sm'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarHeader'
            aria-controls='navbarHeader'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon'></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
